import { Component, OnInit, ViewChild, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { TopNavComponent } from './top-nav/top-nav.component';
import { LeftNavComponent } from './left-nav/left-nav.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { FooterComponent } from './footer/footer.component';
import { DeviceUtilService } from '../util/deviceUtil.service';
import { LocalStorageService } from '../storage/local-storage.service';

const _leftMenuClosedLsKey: string = 'mcLeftMenuClosed';

@Component({
  selector: 'wl-main-container',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'main-container.component.html',
  styleUrls: ['main-container.component.less'],
  standalone: false,
})
export class MainContainerComponent implements OnInit {
  public leftMenuOpen: boolean = true;

  /**
   * text shown on the side of the menu
   */
  @Input() public titleText: string = 'Events';

  /**
   * Construct
   * @param _deviceUtilService
   * @param _localStorageService
   */
  public constructor(
    public _deviceUtilService: DeviceUtilService,
    public _localStorageService: LocalStorageService
  ) {
    let wasClosed: boolean = !!this._localStorageService.getString(_leftMenuClosedLsKey);
    this.leftMenuOpen = !this._deviceUtilService.isExtraSmallScreen() && !wasClosed;
  }

  /**
   * On init
   */
  public ngOnInit() {}

  /**
   * toggle state of the left menu
   */
  public toggleLeftMenu(): void {
    this.leftMenuOpen = !this.leftMenuOpen;
    this._localStorageService.setString(_leftMenuClosedLsKey, this.leftMenuOpen ? '' : '1');
  }
}
